import { apiClientV2 } from '@/services/rest-api/apiClient'

const baseURL = process.env.VUE_APP_API_VMS_URL

const appendPrefixUrl = (prefixUrl = {}, url) =>
  [
    `/vendor/${prefixUrl.vendorId}`,
    `/contract/${prefixUrl.contractId}`,
    `/version/${prefixUrl.versionId}`,
    `${url}`,
  ].join('')

export const create = async (prefixUrl = {}) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: appendPrefixUrl(prefixUrl, `/addendum`),
  })

  return response?.data
}

export const activate = async (prefixUrl = {}, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: appendPrefixUrl(prefixUrl, `/activate`),
    data,
  })

  // If no data but status is 200
  if (!response?.data && String(response?.status).startsWith('2')) {
    return 'OK'
  }

  return response?.data
}

export const getHistory = async (prefixUrl = {}) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/vendor/${prefixUrl.vendorId}/contract/${prefixUrl.contractId}/addendum`,
  })

  return response?.data
}
